import { comunicaapi } from "../../services/api"
import { UsuarioType } from "../../types/UsuarioType"
import { extrairNumeros, removeMask } from "../../utilities/displayValues"

export type Advs = Partial<UsuarioType> & {
    value: string | number
    label: string
}

type ReqBody = {
    busca: string | number
    dataInicial: Date | string | null
    dataFinal: Date | string | null
    protocolo_processo: string
    advogados: Advs[]
}

export async function consultProcessosDJEN(body: ReqBody) {
    try {
        const { busca, dataInicial, dataFinal, protocolo_processo, advogados } = body;
        if (busca === "1") {
            let result = [];
            for (let index = 0; index < advogados.length; index++) {
                const adv = advogados[index];
                const cod_oab = adv.cod_oab || "";
                const sessao_oab_usuario_sigla = adv.sessao_oab_usuario_sigla || "";
                let params = `numeroOab=${extrairNumeros(cod_oab)}&ufOab=${sessao_oab_usuario_sigla}&dataDisponibilizacaoInicio=${dataInicial}&dataDisponibilizacaoFim=${dataFinal}`;
                const response = await comunicaapi.get(`/comunicacao?${params}`);
                if (response.data.status === "success") {
                    if (response.data.items.length > 0) result.push(...response.data.items);
                }
            }
            if (result.length > 0 && advogados.length > 1) {
                const arrayOrdenado = result;

                arrayOrdenado.sort((a, b) => {
                    const dataA = new Date(a.data_disponibilizacao);
                    const dataB = new Date(b.data_disponibilizacao);
                    return dataB.getTime() - dataA.getTime();
                });

                result = arrayOrdenado;
            }
            return result
        } else if (busca === "2") {
            const params = `numeroProcesso=${removeMask(protocolo_processo)}`;
            const response = await comunicaapi.get(`/comunicacao?${params}`);
            if (response.data.status === "success") {
                // const items = response.data.items;
                // for (let index = 0; index < items.length; index++) {
                //     const element = items[index];
                //     const {data_disponibilizacao, destinatarioadvogados, destinatarios, hash, id} = element;
                // }
                return response.data.items;
            } else {
                return [];
            }
        } else {
            return { error: true, msg: 'Modelo de busca não especificado' };
        }
    } catch (error) {
        return { error: true, msg: 'Falha na operação', details: error };
    }
}